import { create } from 'zustand';

export type ModalType = 'confirm' | 'orderDetail' | null;

interface UIStore {
  isSidebarOpen: boolean;
  isMobile: boolean;
  activeModal: ModalType;

  toggleSidebar: () => void;
  openSidebar: () => void;
  closeSidebar: () => void;
  setMobile: (isMobile: boolean) => void;
  openModal: (modal: ModalType) => void;
  closeModal: () => void;
}

export const useUIStore = create<UIStore>((set) => ({
  isSidebarOpen: true,
  isMobile: false,
  activeModal: null,

  toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
  openSidebar: () => set({ isSidebarOpen: true }),
  closeSidebar: () => set({ isSidebarOpen: false }),
  setMobile: (isMobile) => set({ isMobile }),
  openModal: (modal) => set({ activeModal: modal }),
  closeModal: () => set({ activeModal: null }),
}));
